/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { encryptMessage } from '../services/Services';

const HandleFormUtil = (initialFormValues, initialErrors, initialIsLicensedValue, allowNpn) => {
  const history = useHistory();
  const [formValues, setFormValues] = useState(initialFormValues || {});
  const [errors, setErrors] = useState(initialErrors || {});
  const [isLicensed, setIsLicensed] = useState(initialIsLicensedValue ?? false);
  const [licensedData, setLicensedData] = useState(undefined);
  const [showBannerType, setShowBannerType] = useState(undefined);
  const [isEditable, setIsEditable] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const loaderGif = require('../../common/assets/img/loader.gif');
  const loaderStyle = {
    backgroundImage: isLoading ? `url(${loaderGif})` : 'none',
    backgroundPosition: '10px center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '1.5rem 1.5rem',
    paddingLeft: isLoading ? '2.5rem' : '',
  }

  useEffect(() => {
    if (!isLicensed && !allowNpn) {
        delete formValues.npn;
        delete errors.npn;
    }
    const formEmpty = Object.values(formValues).some((value) => value === '');
    const isErrorEmpty = Object.keys(errors).every((key) => errors[key] === '');
    setIsValid(isErrorEmpty && !formEmpty);
    }, [errors]);

  return { history, formValues, setFormValues, errors, setErrors, isLicensed, setIsLicensed, licensedData, setLicensedData, showBannerType, setShowBannerType, isEditable, setIsEditable, isValid, setIsValid, isLoading, setIsLoading, loaderGif, loaderStyle };
};

export {HandleFormUtil as default };
